import { render, staticRenderFns } from "./warehouseDetail.vue?vue&type=template&id=3a7486de&scoped=true"
import script from "./warehouseDetail.vue?vue&type=script&lang=js"
export * from "./warehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./warehouseDetail.vue?vue&type=style&index=0&id=3a7486de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7486de",
  null
  
)

export default component.exports